<template>
  <div>
    <MainLayout>
      <DetailForm
        title="New"
        description="This form will create a new candidate"
        action="Create"
        @handle-cancel="router.go(-1)"
        @handle-action="createContact"
      >
        <ContactForm v-model="contact" />
      </DetailForm>
    </MainLayout>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from 'vue-sonner';
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import DetailForm from '../shared/DetailForm.vue';
import ContactForm from './ContactForm.vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import RailsUtility from '@/utilities/rails';

const router = useRouter();
const loadingSpinnerStore = useLoadingSpinnerStore();

const contact = ref({
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  stage: 'Applied',
  licenseStatus: '',
  reLicenseNumber: '',
  phoneScreenAt: '',
  interviewAt: '',
});

const createContact = (): void => {
  loadingSpinnerStore.showLocalLoadingSpinner();
  fetch('/api/contacts', {
    method: 'POST',
    body: JSON.stringify({
      first_name: contact.value.firstName,
      last_name: contact.value.lastName,
      phone_number: contact.value.phone,
      email: contact.value.email,
      stage: contact.value.stage,
      license_status: RailsUtility.convertToCasedEnumFormat(contact.value.licenseStatus),
      re_license_number: contact.value.reLicenseNumber,
      phone_screen_at: contact.value.phoneScreenAt ? new Date(contact.value.phoneScreenAt).toISOString() : null,
      interview_at: contact.value.interviewAt ? new Date(contact.value.interviewAt).toISOString() : null,
      record_type: 'Candidate',
    }),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': document.querySelectorAll<HTMLMetaElement>('[name="csrf-token"]')[0].content,
    },
  })
    .then(response => response.json())
    .then(async data => {
      loadingSpinnerStore.hideLocalLoadingSpinner();
      if (data.status != 'error') {
        await router.push(`/contacts/${data.record.id}`);
        toast.success('Contact created', {
          action: { label: 'Dismiss' },
          description:
            'Your contact was successfully created.  Use the buttons below to view your new contact, or dismiss this alert.',
        });
      } else {
        toast.error('Contact create error', {
          action: { label: 'Dismiss' },
          description: data.message,
        });
      }
    });
};
</script>
